import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import VueSweetalert2 from 'vue-sweetalert2';
import VueCookies from 'vue3-cookies';
import PerfectScrollbar from "vue3-perfect-scrollbar";
import store from './store'
import Camera from "simple-vue-camera";

import 'sweetalert2/dist/sweetalert2.min.css';
import './assets/vendors/base/vendors.bundle.css';
import './assets/default/base/style.bundle.css';
// import './assets/vendors/custom/fullcalendar/fullcalendar.bundle.css';
//import './assets/vendors/custom/datatables/datatables.bundle.css';
import './assets/modal.css';
import './assets/dropdown.css';
import './assets/cms-refresh.css';
import './assets/list-refresh.css';
import './assets/modal-refresh.css';
import './assets/show-refresh.css';

const app = createApp(App)
// Or to set default config:
app.config.warnHandler = function (msg, vm, trace) {
  return null
}
app.use(VueCookies, {
    expireTimes: "30d",
    path: "/",
    domain: process.env.VUE_APP_DOMAIN,
    secure: process.env.VUE_APP_PRODUCTION == 1 ? true : false,
    sameSite: "None"
});

//app.use(asyncComputed);

app.use(store);
app.use(VueSweetalert2);
app.use(router);
app.use(PerfectScrollbar);
app.component("camera", Camera);
app.mount('#app')
